<template>
  <b-modal id="add-task" ref="addDebtTask" size="lg" :title="$t('debt_tasks.add')" @ok="handleStore" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <div class="form-group">
          <label for="statuses" class="col-form-label">{{ $t('options.statuses') }}</label>
          <select id="statuses" class="form-control" v-model="debt_task.statuses" multiple :class="{'is-invalid': errors.statuses }">
              <option v-for="status in debt_statuses" :value="status.id">
                  {{ status.name }}
              </option>
          </select>
          <small id="statuses" class="form-text text-muted">{{ $t('hints.multiple_statuses') }}</small>
          <span v-if="errors.statuses" class="invalid-feedback">
              <strong>{{ errors.statuses ? errors.statuses[0] : '' }}</strong>
          </span>
      </div>
      <div class="form-group">
          <label for="startdate" class="col-form-label">{{ $t('debt_tasks.start_date') }}</label>
          <input id="startdate" type="datetime-local" class="form-control" v-model="debt_task.start_date" :class="{'is-invalid': errors.start_date }" placeholder="Дата начало">
          <span v-if="errors.start_date" class="invalid-feedback">
              <strong>{{ errors.start_date ? errors.start_date[0] : '' }}</strong>
          </span>
      </div>
      <div class="form-group">
          <label for="enddate" class="col-form-label">{{ $t('debt_tasks.end_date') }}</label>
          <input id="enddate" type="datetime-local" class="form-control" v-model="debt_task.end_date"  :class="{'is-invalid': errors.end_date }" placeholder="Дата начало">
          <span v-if="errors.end_date" class="invalid-feedback">
              <strong>{{ errors.end_date ? errors.end_date[0] : '' }}</strong>
          </span>
      </div>
  </b-modal>
</template>

<script>
export default {
  props: [
    'userId',
  ],
  data() {
    return {
      debt_task: {
        statuses: [],
        start_date: '',
        end_date: '',
      },
      debt_statuses: [],
      errors: {},
      isProcessing: '',
      status_id: '',
    };
  },
  created() {
    this.getDebtStatuses();
  },
  methods: {
    getDebtStatuses() {
      axios.get('/admin/list/debt/statuses')
        .then((res) => {
          this.debt_statuses = res.data.statuses;
        });
    },

    clearModal() {
      this.debt_task = {
        statuses: [],
        start_date: '',
        end_date: '',
      };
    },

    handleStore(event) {
      event.preventDefault();
      this.addDebtTask();
    },

    addDebtTask() {
      this.isProcessing = true;
      this.errors = {};
      axios.post(`/admin/users/${this.userId}/add/debttask`, this.debt_task)
        .then((res) => {
            this.$refs.addDebtTask.hide();
            Swal.fire("Успешно выполнено!", res.data.message, "success");
            this.clearModal();
            this.$emit('fetchUsers');
        })
        .catch((err) => {
            this.errors = this.laravelValidation(err);
        })
        .finally(() => {
            this.isProcessing = false;
        });
    },
  },
};
</script>
